import type { RatingListApiView } from "~~/model/rating.model";

export type RatingListView = RatingListApiView;

export function useRatingList(filters?: {
  tags?: string[];
  limit?: number;
  has_comment?: boolean;
}) {
  return useLazyFetch(`/api/ratings`, {
    query: filters,
    default: () => [] as RatingListView[],
  });
}
